<script>
import { mapGetters } from 'vuex';
import routerMixin from 'widget/mixins/routerMixin';

export default {
  name: 'TabBar',
  mixins: [routerMixin],
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
      unreadMessageCount: 'multi-conversation/getUnreadMessageCount',
    }),
    currentRouteName() {
      return this.$route.name;
    },
    isHomeActive() {
      return (
        this.currentRouteName === 'home' || this.currentRouteName === undefined
      );
    },
    isMessagesActive() {
      return this.currentRouteName === 'messages';
    },
    isHelpActive() {
      return this.currentRouteName === 'help';
    },
  },
  methods: {
    navigateTo(route) {
      this.replaceRoute(route);
    },
  },
};
</script>

<template>
  <div
    class="flex items-center justify-around w-full py-3 bg-white border-t border-t-[rgb(229,229,229)] shadow-[0_0_25px_rgb(229,229,229)] dark:bg-n-solid-1 dark:border-n-solid-3"
  >
    <div
      class="flex flex-col items-center cursor-pointer"
      :style="isHomeActive && { color: widgetColor }"
      @click="navigateTo('home')"
    >
      <span class="w-6 h-6 mb-1">
        <svg
          v-if="isHomeActive"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <mask id="39a1a" fill="#fff">
            <path
              fill-rule="evenodd"
              d="M10.5 2.335 3 7.51c-.625.437-1 1.116-1 1.84V19.7C2 20.965 3.125 22 4.5 22h15c1.375 0 2.5-1.035 2.5-2.3V9.35c0-.724-.375-1.403-1-1.84l-7.5-5.175a2.69 2.69 0 0 0-3 0M7.316 14.366a.85.85 0 1 0-1.132 1.268A8.7 8.7 0 0 0 12 17.852a8.7 8.7 0 0 0 5.816-2.218.85.85 0 1 0-1.132-1.268A7 7 0 0 1 12 16.152c-1.8 0-3.44-.675-4.684-1.786"
              clip-rule="evenodd"
            />
          </mask>
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M10.5 2.335 3 7.51c-.625.437-1 1.116-1 1.84V19.7C2 20.965 3.125 22 4.5 22h15c1.375 0 2.5-1.035 2.5-2.3V9.35c0-.724-.375-1.403-1-1.84l-7.5-5.175a2.69 2.69 0 0 0-3 0M7.316 14.366a.85.85 0 1 0-1.132 1.268A8.7 8.7 0 0 0 12 17.852a8.7 8.7 0 0 0 5.816-2.218.85.85 0 1 0-1.132-1.268A7 7 0 0 1 12 16.152c-1.8 0-3.44-.675-4.684-1.786"
            clip-rule="evenodd"
          />
          <path
            fill="currentColor"
            d="m3 7.51-.965-1.4-.01.007zm7.5-5.175L9.538.934l-.003.002zM21 7.51l.974-1.393-.009-.006zm-7.5-5.175.966-1.4-.004-.001zM6.116 14.434l1.268 1.132zm1.2-.068 1.133-1.268zm-1.132 1.268L5.05 16.902zm11.632 0 1.133 1.268zm.068-1.2-1.268 1.132zm-1.2-.068-1.133-1.268zM3.965 8.91l7.5-5.175L9.536.936l-7.5 5.175zm-.265.44c0-.12.063-.299.274-.447L2.026 6.117C.987 6.843.3 8.022.3 9.35zm0 10.35V9.35H.3V19.7zm.8.6a.9.9 0 0 1-.615-.227.5.5 0 0 1-.185-.373H.3c0 2.335 2.022 4 4.2 4zm15 0h-15v3.4h15zm.8-.6a.5.5 0 0 1-.185.373.9.9 0 0 1-.615.227v3.4c2.178 0 4.2-1.665 4.2-4zm0-10.35V19.7h3.4V9.35zm-.274-.447c.211.148.274.326.274.447h3.4c0-1.328-.687-2.507-1.726-3.233zm-7.491-5.169 7.5 5.175 1.93-2.798-7.5-5.175zm-1.073.002a.99.99 0 0 1 1.076 0L14.462.934a4.39 4.39 0 0 0-4.924 0zm-4.078 11.83a.85.85 0 0 1-1.2.068l2.265-2.536a2.55 2.55 0 0 0-3.6.203zm-.068-1.2c.35.313.38.85.068 1.2l-2.536-2.265a2.55 2.55 0 0 0 .203 3.6zM12 16.152c-1.8 0-3.44-.675-4.684-1.786l-2.265 2.536A10.4 10.4 0 0 0 12 19.552zm4.684-1.786A7 7 0 0 1 12 16.152v3.4c2.667 0 5.105-1.004 6.949-2.65zm-.068 1.2a.85.85 0 0 1 .068-1.2l2.265 2.536a2.55 2.55 0 0 0 .203-3.6zm1.2.068a.85.85 0 0 1-1.2-.068l2.536-2.265a2.55 2.55 0 0 0-3.6-.203zM12 17.852a8.7 8.7 0 0 0 5.816-2.218l-2.265-2.536A5.3 5.3 0 0 1 12 14.452zm-5.816-2.218A8.7 8.7 0 0 0 12 17.852v-3.4a5.3 5.3 0 0 1-3.551-1.354z"
            mask="url(#39a1a)"
          />
        </svg>

        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-width="1.7"
            d="M2.85 9.35c0-.423.218-.85.635-1.143l7.496-5.172h.001a1.84 1.84 0 0 1 2.036 0l7.495 5.17.002.002c.417.293.635.72.635 1.142V19.7c0 .73-.676 1.45-1.65 1.45h-15c-.974 0-1.65-.72-1.65-1.45z"
            class="10f122d8stroke"
          />
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-width="1.7"
            d="M17.25 15A7.86 7.86 0 0 1 12 17.002 7.86 7.86 0 0 1 6.75 15"
            class="10f122d8stroke"
          />
        </svg>
      </span>
      <span class="text-sm" :class="{ 'font-bold': isHomeActive }">
        {{ $t('HOME') }}
      </span>
    </div>

    <div
      class="flex flex-col items-center cursor-pointer"
      :style="isMessagesActive && { color: widgetColor }"
      @click="navigateTo('messages')"
    >
      <span class="w-6 h-6 mb-1 relative">
        <svg
          v-if="isMessagesActive"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <mask id="1180a" fill="#fff">
            <path
              fill-rule="evenodd"
              d="M22 5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10.558l3.883 3.87c.946.942 2.559.272 2.559-1.063zm-4.15 2.85A.85.85 0 0 0 17 7H7a.85.85 0 0 0 0 1.7h10c.47 0 .85-.38.85-.85m-5 4A.85.85 0 0 0 12 11H7a.85.85 0 0 0 0 1.7h5c.47 0 .85-.38.85-.85"
              clip-rule="evenodd"
            />
          </mask>
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M22 5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10.558l3.883 3.87c.946.942 2.559.272 2.559-1.063zm-4.15 2.85A.85.85 0 0 0 17 7H7a.85.85 0 0 0 0 1.7h10c.47 0 .85-.38.85-.85m-5 4A.85.85 0 0 0 12 11H7a.85.85 0 0 0 0 1.7h5c.47 0 .85-.38.85-.85"
            clip-rule="evenodd"
          />
          <path
            fill="currentColor"
            d="M15.558 18v-1.7h.702l.498.496zm3.883 3.87 1.2-1.205zM19 .3A4.7 4.7 0 0 1 23.7 5h-3.4A1.3 1.3 0 0 0 19 3.7zM5 .3h14v3.4H5zM.3 5A4.7 4.7 0 0 1 5 .3v3.4A1.3 1.3 0 0 0 3.7 5zm0 10V5h3.4v10zM5 19.7A4.7 4.7 0 0 1 .3 15h3.4A1.3 1.3 0 0 0 5 16.3zm10.558 0H5v-3.4h10.558zm2.683 3.374-3.883-3.87 2.4-2.408 3.883 3.87zm5.459-2.267c0 2.848-3.441 4.277-5.459 2.267l2.4-2.409a.23.23 0 0 0-.218-.043.23.23 0 0 0-.123.185zm0-4.307v4.307h-3.4V16.5zm0-2.543V16.5h-3.4v-2.543zM23.7 5v8.957h-3.4V5zm-6.7.3a2.55 2.55 0 0 1 2.55 2.55h-3.4c0 .47.38.85.85.85zm-10 0h10v3.4H7zM4.45 7.85A2.55 2.55 0 0 1 7 5.3v3.4c.47 0 .85-.38.85-.85zM7 10.4a2.55 2.55 0 0 1-2.55-2.55h3.4A.85.85 0 0 0 7 7zm10 0H7V7h10zm2.55-2.55A2.55 2.55 0 0 1 17 10.4V7a.85.85 0 0 0-.85.85zM12 9.3a2.55 2.55 0 0 1 2.55 2.55h-3.4c0 .47.38.85.85.85zm-5 0h5v3.4H7zm-2.55 2.55A2.55 2.55 0 0 1 7 9.3v3.4c.47 0 .85-.38.85-.85zM7 14.4a2.55 2.55 0 0 1-2.55-2.55h3.4A.85.85 0 0 0 7 11zm5 0H7V11h5zm2.55-2.55A2.55 2.55 0 0 1 12 14.4V11a.85.85 0 0 0-.85.85z"
            mask="url(#1180a)"
          />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <mask id="913ba" fill="#fff">
            <path
              fill-rule="evenodd"
              d="M19 2a3 3 0 0 1 3 3v15.806c0 1.335-1.613 2.005-2.559 1.062L15.56 18H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3z"
              clip-rule="evenodd"
            />
          </mask>
          <path
            fill="currentColor"
            d="m19.441 21.868 1.2-1.204zM15.56 18v-1.7h.702l.498.496zM20.3 5A1.3 1.3 0 0 0 19 3.7V.3A4.7 4.7 0 0 1 23.7 5zm0 8.956V5h3.4v8.956zm0 2.544v-2.544h3.4V16.5zm0 4.306V16.5h3.4v4.306zm.341-.142a.23.23 0 0 0-.218-.043.23.23 0 0 0-.123.185h3.4c0 2.848-3.441 4.277-5.459 2.267zm-3.882-3.868 3.882 3.868-2.4 2.409-3.882-3.869zM5 16.3h10.559v3.4H5zM3.7 15A1.3 1.3 0 0 0 5 16.3v3.4A4.7 4.7 0 0 1 .3 15zm0-10v10H.3V5zM5 3.7A1.3 1.3 0 0 0 3.7 5H.3A4.7 4.7 0 0 1 5 .3zm14 0H5V.3h14z"
            class="ff96f8cdfill"
            mask="url(#913ba)"
          />
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M17 7a.85.85 0 0 1 0 1.7H7A.85.85 0 1 1 7 7zm-5 4a.85.85 0 0 1 0 1.7H7A.85.85 0 0 1 7 11z"
            class="ff96f8cdfill"
            clip-rule="evenodd"
          />
        </svg>
        <span
          v-if="unreadMessageCount > 0"
          class="absolute -top-1 -right-1 flex items-center justify-center w-4 h-4 text-xs text-white bg-red-500 rounded-full"
        >
          {{ unreadMessageCount }}
        </span>
      </span>
      <span class="text-sm" :class="{ 'font-bold': isMessagesActive }">
        {{ $t('MESSAGES') }}
      </span>
    </div>

    <div
      class="flex flex-col items-center cursor-pointer"
      :style="isHelpActive && { color: widgetColor }"
      @click="navigateTo('help')"
    >
      <span class="w-6 h-6 mb-1">
        <svg
          v-if="isHelpActive"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <mask id="da2ba" fill="#fff">
            <path
              fill-rule="evenodd"
              d="M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12M11.926 7.85a1.56 1.56 0 0 0-1.465 1.02.85.85 0 1 1-1.594-.588 3.26 3.26 0 1 1 5.547 3.233l-.019.022-.02.021-1.075 1.105-.006.006-.006.006c-.319.315-.512.534-.512.94v.363a.85.85 0 0 1-1.7 0v-.364c0-1.144.664-1.8 1.003-2.134l.009-.008 1.046-1.076a1.56 1.56 0 0 0-1.208-2.546m0 9.917a.884.884 0 1 0 0-1.767.884.884 0 0 0 0 1.767"
              clip-rule="evenodd"
              shape-rendering="crispEdges"
            />
          </mask>
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12M11.926 7.85a1.56 1.56 0 0 0-1.465 1.02.85.85 0 1 1-1.594-.588 3.26 3.26 0 1 1 5.547 3.233l-.019.022-.02.021-1.075 1.105-.006.006-.006.006c-.319.315-.512.534-.512.94v.363a.85.85 0 0 1-1.7 0v-.364c0-1.144.664-1.8 1.003-2.134l.009-.008 1.046-1.076a1.56 1.56 0 0 0-1.208-2.546m0 9.917a.884.884 0 1 0 0-1.767.884.884 0 0 0 0 1.767"
            clip-rule="evenodd"
          />
          <path
            fill="currentColor"
            d="m10.462 8.87 1.595.588zm-1.092.503-.588 1.595zm-.503-1.091-1.595-.589zm5.547 3.233-1.297-1.099zm-.019.022 1.22 1.185.04-.042.038-.044zm-.02.021 1.219 1.186zM13.3 12.663l1.22 1.185zm-.006.006 1.195 1.21.012-.012.012-.013zm-.006.006-1.194-1.21zM12.08 11.48l1.194 1.21zm.009-.008 1.194 1.21.012-.013.013-.012zm1.046-1.076 1.218 1.186.051-.053.046-.056zM12 24.2c6.738 0 12.2-5.462 12.2-12.2h-3.4a8.8 8.8 0 0 1-8.8 8.8zM-.2 12c0 6.738 5.462 12.2 12.2 12.2v-3.4A8.8 8.8 0 0 1 3.2 12zM12-.2C5.262-.2-.2 5.262-.2 12h3.4A8.8 8.8 0 0 1 12 3.2zM24.2 12C24.2 5.262 18.738-.2 12-.2v3.4a8.8 8.8 0 0 1 8.8 8.8zM12.057 9.458a.14.14 0 0 1-.05.065.15.15 0 0 1-.081.027v-3.4a3.26 3.26 0 0 0-3.06 2.132zm-3.275 1.51a2.55 2.55 0 0 0 3.274-1.51l-3.19-1.176a.85.85 0 0 1 1.092-.504zm-1.51-3.275a2.55 2.55 0 0 0 1.51 3.275l1.176-3.19a.85.85 0 0 1 .503 1.092zm4.654-3.243a4.96 4.96 0 0 0-4.654 3.243l3.19 1.177a1.56 1.56 0 0 1 1.464-1.02zm4.96 4.96a4.96 4.96 0 0 0-4.96-4.96v3.4c.861 0 1.56.698 1.56 1.56zm-1.174 3.203a4.95 4.95 0 0 0 1.173-3.203h-3.4c0 .384-.138.734-.368 1.006zm-.019.023.019-.023-2.595-2.197-.02.023zm-.1.108.021-.021-2.437-2.371-.02.021zm-1.074 1.104 1.075-1.104-2.438-2.371-1.074 1.105zm-.006.006.006-.006-2.437-2.37-.006.006zm-.03.031.006-.006-2.389-2.42-.006.007zm-.007-.27a.8.8 0 0 1-.112.382c-.025.04-.039.052-.018.028.023-.026.06-.065.137-.14l-2.389-2.42c-.33.326-1.018.985-1.018 2.15zm0 .363v-.364h-3.4v.364zm-2.55 2.55a2.55 2.55 0 0 0 2.55-2.55h-3.4c0-.47.38-.85.85-.85zm-2.55-2.55a2.55 2.55 0 0 0 2.55 2.55v-3.4c.469 0 .85.38.85.85zm0-.364v.364h3.4v-.364zm1.51-3.344c-.372.366-1.51 1.455-1.51 3.344h3.4c0-.4.19-.621.497-.923zm.008-.009-.009.01 2.388 2.42.009-.01zm1.021-1.05-1.046 1.075 2.438 2.37 1.045-1.074zm-.13.199a.14.14 0 0 1 .033-.09l2.631 2.153a3.25 3.25 0 0 0 .736-2.063zm.14.14a.14.14 0 0 1-.14-.14h3.4c0-1.8-1.46-3.26-3.26-3.26zm-.815 7.334c0-.451.366-.817.817-.817v3.4a2.584 2.584 0 0 0 2.583-2.583zm.817.816a.816.816 0 0 1-.817-.816h3.4a2.584 2.584 0 0 0-2.583-2.584zm.816-.816c0 .45-.366.816-.816.816v-3.4a2.584 2.584 0 0 0-2.584 2.584zm-.816-.817c.45 0 .816.366.816.817h-3.4a2.584 2.584 0 0 0 2.584 2.583z"
            mask="url(#da2ba)"
          />
        </svg>
        <svg
          v-else
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            cx="12"
            cy="12"
            r="9.65"
            stroke="currentColor"
            stroke-width="1.7"
            class="2214a7dbstroke 069fb33bcircle"
          />
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-width="1.7"
            d="M9.664 8.576a2.41 2.41 0 1 1 4.102 2.39l-1.075 1.104c-.326.322-.765.76-.765 1.544v.364"
            class="2214a7dbstroke 82ecd0dcnegative"
          />
          <circle
            cx="11.927"
            cy="16.884"
            r="0.884"
            fill="currentColor"
            class="a1241b2cfill 82ecd0dcnegative"
          />
        </svg>
      </span>
      <span class="text-sm" :class="{ 'font-bold': isHelpActive }">
        {{ $t('HELP') }}
      </span>
    </div>
  </div>
</template>
